import buildWhatsappMessage from './buildWhatsappMessage';
import parseUrl from './parseUrl';

const EXISTING_PROTOCOL_TAG_PATTERN = /\s*\n*_Protocolo:[^_]*_/g;

/**
 * Pressupõe que `url` já foi validada como um link de WhatsApp (ver `isWhatsappLink`).
 */
export default function appendWhatsappProtocolToLink(
  url: string,
  protocolId: string,
) {
  const parsedUrl = parseUrl(url);
  const currentMessage = (parsedUrl.searchParams.get('text') ?? '').replace(
    EXISTING_PROTOCOL_TAG_PATTERN,
    '',
  );

  parsedUrl.searchParams.set(
    'text',
    buildWhatsappMessage({ message: currentMessage, protocolId }),
  );

  return parsedUrl.toString();
}
